/**
*
* Close / Open the mobile nav
*
*/
function toggleMobileNav() {
    $mobileMenu.toggleClass('-translate-x-full')
    $mobileMenu.toggleClass('is-active')
    $('body')
        .toggleClass('overflow-hidden')
        .toggleClass('mobile-nav-open')
}

/**
*
* Toggle the hamburger
*
*/
let $mobileMenu = $('[data-mobile-menu]')
$mobileMenu.show();
let $hamburger = $('[data-hamburger]')
$hamburger.on('click', function(e){
    $(this).toggleClass('is-active')
    e.preventDefault()
    toggleMobileNav()
})

/**
*
* Toggle the navigation with the close button
*
*/
let $mobileMenuClose = $('[data-mobile-menu-close]')
$mobileMenuClose.on('click', function(e){
    e.preventDefault()
    $hamburger.toggleClass('is-active')
    toggleMobileNav()
})

/**
*
* Toggle the 'Boost' search.
*
*/
let $searchToggle = $('[data-search-toggle]')
$searchToggle.on('click', function(e){
    e.preventDefault()
    // console.log($('.boost-pfs-search-suggestion-mobile-top-panel'))
    // $('.boost-pfs-search-suggestion-mobile-top-panel').toggle()
    $('[data-search-container]').toggleClass('is--active')
    $('body').toggleClass('search--active')
})

/**
*
* Allow clicking outside of the mobile nav
*
*/
$('body').on('click', function(e) {

    if ( $(e.target).closest('.mobile-menu').length == 0 &&
         $(e.target).closest('[data-hamburger]').length == 0 &&
         $('body').hasClass('mobile-nav-open') ) {
            $hamburger.toggleClass('is-active')
            toggleMobileNav()
    }

    // Allow for the mega menu outside to be clicked to close, on IE
    if (theme.oldBrowsers.isIE11 || theme.oldBrowsers.isIE10Down) {
        if ( $(e.target).closest('[data-mega-menu]').length == 0) {
            $('[data-mega-menu]').addClass('hidden')
        }
    }


})
